// import Swiper bundle with all modules installed
import Swiper, { Navigation, Pagination, Autoplay, EffectFade, Scrollbar } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Scrollbar]);

export default {
  init() {
    // console.log('Homepage');

    const kawaBtn = $('#carousel-btn-kawa');
    const herbataBtn = $('#carousel-btn-herbata');
    const kawaNav = $('#nav-btns-kawa');
    const herbataNav = $('#nav-btns-herbata');
    const kawaCarousel = $('#kawa-container');
    const herbataCarousel = $('#herbata-container');
    // const bestsellersCarousel = $('#bestsellers-container'); // usunięte, bo nieużywane

    // Obsługa przycisków kategorii
    kawaBtn.on('click', function () {
      // console.log('KAWA CLICK');
      if (!$(this).hasClass('active')) {
        $('.carousel-category-btn').removeClass('active');
        $('.carousel-nav-btns').removeClass('active');
        $(this).addClass('active');
        herbataNav.fadeOut();
        kawaNav.fadeIn();
        herbataCarousel.removeClass('active');
        kawaCarousel.delay(300).addClass('active');
      }
    });

    herbataBtn.on('click', function () {
      // console.log('HERBATA CLICK');
      if (!$(this).hasClass('active')) {
        $('.carousel-category-btn').removeClass('active');
        $('.carousel-nav-btns').removeClass('active');
        $(this).addClass('active');
        kawaNav.fadeOut();
        herbataNav.fadeIn();
        kawaCarousel.removeClass('active');
        herbataCarousel.delay(300).addClass('active');
      }
    });

    // Inicjalizacja slidera głównego
    new Swiper('#homepage-slider', {
      slidersPerView: 1,
      speed: 800,
      loop: true,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      virtualTranslate: true,
      autoplay: {
        delay: 6000,
        disableOnInteraction: true,
      },
      navigation: {
        nextEl: '.slider-prev',
        prevEl: '.slider-next',
      },
    });

    $('.kawa-container.swiper-container').append('<div class="swiper-scrollbar"></div>');
    $('.herbata-container.swiper-container').append('<div class="swiper-scrollbar"></div>');
    $('.bestsellers-container.swiper-container').append('<div class="swiper-scrollbar"></div>');

    // Inicjalizacja slidera "kawa"
    new Swiper('.kawa-container', {
      slidesPerView: 'auto',
      spaceBetween: 30,
      // loop: true,
      breakpoints: {
        992: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
      autoplay: {
        delay: 6000,
        disableOnInteraction: true,
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      },
      navigation: {
        nextEl: '.button-prev-kawa',
        prevEl: '.button-next-kawa',
      },
    });

    // Inicjalizacja slidera "herbata"
    new Swiper('.herbata-container', {
      slidesPerView: 'auto',
      spaceBetween: 30,
      // loop: true,
      breakpoints: {
        992: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
      },
      autoplay: {
        delay: 6000,
        disableOnInteraction: true,
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      },
      navigation: {
        nextEl: '.button-prev-herbata',
        prevEl: '.button-next-herbata',
      },
    });

    // Inicjalizacja slidera "bestsellers"
    new Swiper('.bestsellers-container', {
      slidesPerView: 'auto',
      spaceBetween: 30,
      // loop: true,
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      },
      breakpoints: {
        992: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
      autoplay: {
        delay: 6000,
        disableOnInteraction: true,
      },
      navigation: {
        nextEl: '.button-prev-bestsellers',
        prevEl: '.button-next-bestsellers',
      },
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/homepage.js